// == Import npm
import React from "react";
import { Button, Modal, Typography } from "antd";

// == Import SCSS
import "./modalIPDifference.less";

// == Import icons
import { ReactComponent as Printer } from "assets/illustrations/print.svg";

// == Import components

import { useTranslation } from "react-i18next";

const ModalIPDifference = ({ isVisible, onClose, ipFound, ipConfigured }) => {
  const [t] = useTranslation();

  return (
    <div>
      <Modal
        className="modalIP"
        width="700px"
        open={isVisible}
        onOk={onClose}
        onCancel={onClose}
        footer={
          <>
            <Button
              type="primary"
              style={{ width: "150px" }}
              size="large"
              className="modalIP__modal__yes"
              onClick={onClose}
            >
              {t("Close")}
            </Button>
          </>
        }
      >
        <Printer />
        <div className="modalDelete__modal__text">
          <Typography.Paragraph
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              margin: "10px 0 0 20px",
              overflowWrap: "breack-word",
            }}
          >
            {t("PrinterAlert")}
          </Typography.Paragraph>
          <Typography.Paragraph
            style={{
              fontSize: "14px",
              margin: "10px 0 0 20px",
              overflowWrap: "breack-word",
            }}
          >
            {t("PrinterIPDiffer", { ipFound, ipConfigured })}
          </Typography.Paragraph>
        </div>
      </Modal>
    </div>
  );
};

export default ModalIPDifference;
